export default __webpack_public_path__ + "static/2-6e916b595cc7073c84682c9478186c01.png";